module.exports = __webpack_public_path__ + "static/media/2020.10.1环境整治大讨论.b3ce24ff.jpg";